import React, { useState } from 'react';
import { mapDivEnterToClick, setFocus } from '../../misc/tools';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

interface PalpitationDataItem {
	x: number;
	y: number;
	messages: string[];
	isHovered?: boolean;
	isClicked?: boolean;
	correctButtonIndx: number;
	identifiedText?: string;
}

var areAllSelectionsCorrect = true;
var incorrectCount = 0;

var palpitationData: PalpitationDataItem[] = [
	{
		x: 960,
		y: 222,
		messages: [
			'Feel a midline ridge on a cartilaginous structure.',
			'Tap to Identify'
		],
		correctButtonIndx: 0
	}, {
		x: 960,
		y: 290,
		messages: [
			'Feel an indentation of pliable tissue.',
			'Tap to Identify'
		],
		correctButtonIndx: 2,
	}, {
		x: 960,
		y: 358,
		messages: [
			'Feel a firm cartilaginous ring structure.',
			'Tap to Identify'
		],
		correctButtonIndx: 1,
	}, {
		x: 1028,
		y: 290,
		messages: [
			'Feel a pulsatile structure.',
			'Tap to Identify'
		],
		correctButtonIndx: 3,
	}
]; 

enum Window {
	initial,
	palpate,
	identify
}
var currentlySelectedIndex = 0;

const PalpateNeckUI = (props: UIProperties<PalpateNeckUIConfig>) => {
	const [windowState, setWindowState] = useState(Window.initial);
	const [forceUpdate, setForceUpdate] = useState(false);
	const renderInitialWindow = () => {
		return (
			<div className="modal-disable-select" >
				<img src="./assets/images/palpate-ui/cric_circle.png" alt="" style={{
					position: 'absolute',
					top: '249px',
					left: '912px',
					width: '150px',
					opacity: 0.53,
					pointerEvents: 'all'
				}} tabIndex={0} id='cric-palpate-ui-top' role='button' aria-label= 'Click here to palpate neck and identify landmarks.' onKeyUp={mapDivEnterToClick} onClick={() => {
					setWindowState(Window.palpate);
					setTimeout(() => {
						setFocus('cric-palpate-ui-top');
					}, 500);
				}}/>
				<div tabIndex={0} id='cric-palpate-ui-bottom' aria-label='end of U I'>

				</div>
				<PalpateNeckMessageUI 
					x={1170}
					y={222}
					width={330}
					id='cric-palpate-ui-bottom'
					height={190}
					messages={[
						'Click here to palpate neck and identify landmarks.'
					]}
					></PalpateNeckMessageUI>
			</div>
		)
	};
	const renderPalpateWindow = () => {
		return (
			<div style={{
				pointerEvents: 'all'
			}}>
				{palpitationData.map((dataItem: PalpitationDataItem, indx: number) => {
					const getId = (index: number) => {
						if(index === 0) {
							return 'cric-palpate-ui-top'
						} else if(index === palpitationData.length - 1) {
							return 'cric-palpate-ui-bottom'
						} else {
							return 'palpate-item-' + index
						}
					}
					return (
						<div>
							{!dataItem.isClicked ? (<div style={{
								backgroundColor: props.parameters.isDebug ? 'transparent' : '',
								position: 'absolute',
								left: dataItem.x,
								top: dataItem.y,
								width: '50px',
								height: '50px'
							}} tabIndex={0} onFocus={
								(evt: any) => {
									for(var i = 0; i < palpitationData.length; i++) {
										if(palpitationData[i].isHovered) {
											palpitationData[i].isHovered = false;
										}
									}

									palpitationData[indx].isHovered = true;
									setForceUpdate(!forceUpdate);
								}
							} id={getId(indx)} aria-label={dataItem.identifiedText ? dataItem.identifiedText : dataItem.messages.join('. ')} role='button' onMouseEnter={() => {
								palpitationData[indx].isHovered = true;
								setForceUpdate(!forceUpdate);
							}} onMouseLeave={() => {
								palpitationData[indx].isHovered = false;
								setForceUpdate(!forceUpdate);
							}} onKeyUp={mapDivEnterToClick}  onClick={() => {
								palpitationData[indx].isClicked = true;
								palpitationData[indx].isHovered = false;
								currentlySelectedIndex = indx;
								setWindowState(Window.identify);
							}}>

							</div>) : (null) }
							{dataItem.isHovered ? <PalpateNeckMessageUI 
								x={dataItem.x  + 100}
								y={dataItem.y}
								width={370}
								height={170}
								messages={dataItem.identifiedText ? [dataItem.identifiedText] : dataItem.messages}
								></PalpateNeckMessageUI> : (null)}
						</div>
					);
				})}
			</div>
		);
	};
	const renderIdentifyWindow = () => {
		return (
			<div style={{
				pointerEvents: 'all'
			}}>
				{palpitationData.map((dataItem: PalpitationDataItem, indx: number) => {
					var bttnTxts = [
						'Thyroid cartilage',
						'Cricoid cartilage',
						'Cricothyroid membrane',
						'Common Carotid Artery'
					];
					const isCorrect = (correctIndx: number) => {
						var isCorrect = dataItem.correctButtonIndx === correctIndx;
						if(isCorrect) {
							palpitationData[indx].identifiedText = bttnTxts[correctIndx]
							var identifiedCount = palpitationData.filter(pd => pd.identifiedText).length;
							if(identifiedCount === palpitationData.length) {
								props.parameters.onFinished(areAllSelectionsCorrect);
							} else {
								setWindowState(Window.palpate);
							}
						}

						props.parameters.onSingleLandmarkSelected(isCorrect);
						return isCorrect;
					}
					return indx === currentlySelectedIndex ? (
						<PalpateIdentifyUI 
							x={dataItem.x  + 100}
							y={dataItem.y}
							incorrectMessages={props.parameters.incorrectMessages}
							onFailed={props.parameters.onFailed}
							buttons= {[
								{
									title: bttnTxts[0],
									isCorrect: () => isCorrect(0)
								},
								{
									title: bttnTxts[1],
									isCorrect: () => isCorrect(1)
								}, 
								{
									title: bttnTxts[2],
									isCorrect: () => isCorrect(2)
								},
								{
									title: bttnTxts[3],
									isCorrect: () => isCorrect(3)
								}
							]}></PalpateIdentifyUI>
					) : (null);
				})}
			</div>
		);
	}
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			{windowState !== Window.initial ? palpitationData.map((dataItem: PalpitationDataItem, indx: number) => {
				return (
					dataItem.isClicked ? (<div>
						<img style={{
							position: 'absolute',
							left: dataItem.x,
							top: dataItem.y,
							width: '50px',
							pointerEvents: 'all'
						}} src="./assets/images/palpate-ui/cric_circle2.png" onMouseOver={() => {
							if(windowState === Window.palpate) {
								palpitationData[indx].isHovered = true;
								setForceUpdate(!forceUpdate);
							}
						}} onMouseLeave={() => {
							if(windowState === Window.palpate) {
								palpitationData[indx].isHovered = false;
								setForceUpdate(!forceUpdate);
							}
						}} />
					</div>) : (null)
				);
			}) : (null)}
			{windowState === Window.initial ? (renderInitialWindow()) : (null)}
			{windowState === Window.palpate ? (renderPalpateWindow()) : (null)}
			{windowState === Window.identify ? (renderIdentifyWindow()) : (null)}
		</div>
	);

};

export interface PalpateNeckUIConfig extends BaseConfig{
	isDebug: boolean;
	onFailed: () => void;
	incorrectMessages: string[];
	onSingleLandmarkSelected: (isCorrect: boolean) => void;
	onFinished: (isCorrect: boolean) => void;
}

export default PalpateNeckUI;

const PalpateNeckMessageUI = (props: PalpateNeckMessageUIConfig) => {
	const fullText = () => {
		return props.messages.join('. ');
	}
	return (
		<div style={{
			position: 'absolute',
			top: props.y + 'px',
			left: props.x + 'px',
			width: props.width + 'px',
			height: props.height + 'px',
			border: '3px solid rgb(192, 161, 6)',
			backgroundColor: 'rgb(36, 36, 36)'
			
		}} id={props.id} tabIndex={props.isTabbable ? 0 : -1} aria-label={fullText()}>
			{props.messages.map((msg: string, indx: number)=> {
				var top = '10px';
				var transform = 'translate(-50%, 0)';
				
				if(props.messages.length === 1) {
					top = '50%';
					transform = 'translate(-50%, -50%)';
				}
				
				return (<p style={{
					position: 'relative',
					left: '50%',
					top: top,
					transform: transform,
					fontSize: '22pt',
					margin: '0',
					width: '85%',
					textAlign: 'center'
				}} className='title-font'>{msg}</p>);
			})}
		</div>
	);

};

interface PalpateNeckMessageUIConfig extends BaseConfig{
	x: number;
	y: number;
	id?: string;
	isTabbable?: boolean;
	width: number;
	height: number;
	messages: string[];
}

var feedbackText: string = undefined;

const PalpateIdentifyUI = (props: PalpateIdentifyUIConfig) => {
	const [showFeedback, setShowFeedback] = useState(false);
	var usedFirst = false;
	return (
		<div style={{
			position: 'absolute',
			top: '0',
			left: '0',  
			width: '100%',
			height: '100%',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'absolute',
				top: props.y + 'px',
				left: props.x + 'px',
				width: '380px',
				height: '420px',
				pointerEvents: 'all',
				border: '3px solid rgb(192, 161, 6)',
				backgroundColor: 'rgb(36, 36, 36)'
			}}>
				<div style={{
					width: '100%',
					height: '420px',
					position: 'relative',
					top: '0',
					left: '0'
				}}>
					{!showFeedback ? (<div style={{

					}}>
						{props.buttons.map((button: PalpateIdentifyButtonUIConfig, index: number) => {
							const getId = () => {
								if(index === 0) {
									return 'cric-palpate-ui-top'
								}
							}
							return (
								<CustomPalpateIdentifyButton 
									position={{
										type: 'relative',
										left: '20px',
										top: '20px'
									}}
									id={getId()}
									isDisabled={false}
									text={button.title}
									onClicked={() => {
										var isCorrect = button.isCorrect();
										if(!isCorrect) {
											incorrectCount++;
											feedbackText = props.incorrectMessages && props.incorrectMessages.length > index ? props.incorrectMessages[index] : 'That is not the correct anatomical landmark. Press Continue and try again.';
											setShowFeedback(true);
											areAllSelectionsCorrect = false;
											if(incorrectCount >= 3) {
												if(props.onFailed) {
													props.onFailed();
												}
											}
										}
									}}
								/>
							)
						})}
						<div tabIndex={0} id='cric-palpate-ui-bottom' aria-label='end of U I'></div>
					</div>): (null)}
					{showFeedback ? (<div style={{

					}}>
						<div style={{
							position: 'relative',
							top: '20px'
						}}>
							<p className='title-font' style={{
								textAlign: 'center',
								margin: '0',
								fontSize: '26pt',
								fontWeight: 'normal'
							}} tabIndex={0} id='cric-palpate-ui-top'>{feedbackText}</p>
						</div>
						<CustomPalpateIdentifyButton 
							position={{
								type: 'absolute',
								left: '20px',
								top: '310px'
							}}
							id='cric-palpate-ui-bottom'
							isDisabled={false}
							text="Continue"
							onClicked={() => {
								setShowFeedback(false);
							}}
						/>
					</div>): (null)}
				</div>
			</div>
		</div>
	);

};

const CustomPalpateIdentifyButton = (props: CustomPalpateIdentifyButtonConfig) => {
	return (
		<div style={{
			position: props.position.type ? props.position.type : 'relative',
			top: props.position.top,
			left: props.position.left,
			width: '340px',
			height: '95px',
			pointerEvents: 'none'
		}}>
			<div style={{
				position: 'relative'
			}}>
				<GeneralButtonWithText parameters= {{
					text: '',
					top: '0px',
					left: '0px',
					id: props.id,
					ariaLbl: props.text,
					isDisabled: props.isDisabled,
					width: '330px',
					srcIdle: './assets/images/main-menu/button_menu_exit.png',
					srcHighlight: './assets/images/main-menu/button_menu_exit_down.png',
					srcDisabled: null,
					customMainStyle: {
						position: 'relative',
						width: '100%',
						height: '90px'
					},
					customButtonStyle: {
						width: '100%',
						height: '90px'
					},
					customImgStyle: {
						width: '100%',
						height: '90px'
					},
					onClicked: () => {
						setTimeout(() => {
							setFocus('cric-palpate-ui-top')
						}, 500);
						if(props.onClicked) {
							props.onClicked();
						}
					}
				}}/>
				
				<div style={{
					position: 'absolute',
					height: '30px',
					pointerEvents: 'none',
					width: '100%',
					left: '0',
					top: '50%',
					transform: 'translate(0, -50%)'
				}}>
					<div style={{
						position: 'relative',
						top: '50%',
						transform: 'translate(0, -50%)'
					}}>
						<p className='title-font' style={{
							textAlign: 'center',
							margin: '0',
							fontSize: '16pt',
							fontWeight: 'normal'
						}}>{props.text}</p>
					</div>
					
				</div>
			</div>
		</div>
	);

};

interface CustomPalpateIdentifyButtonConfig {
	text: string;
	id: string;
	isDisabled: boolean;
	position: CustomPalpateIdentifyButtonPosition;
	onClicked?: () => void;
}

interface CustomPalpateIdentifyButtonPosition {
	type?: any;
	left: string;
	top: string;
}

interface PalpateIdentifyUIConfig extends BaseConfig{
	x: number;
	y: number;
	buttons: PalpateIdentifyButtonUIConfig[];
	incorrectMessages: string[];
	onFailed: () => void;
}

interface PalpateIdentifyButtonUIConfig extends BaseConfig{
	title: string;
	isCorrect: () => boolean;
}